import React,  { useEffect, useState } from 'react';
import { Typography, Box, Button,FormControl,
  InputLabel,
  MenuItem,
  Select, TextField } from '@mui/material';
import { Dialog, useToggle,DataGrid } from '@genesis/ui-kit';
import Slide from '@mui/material/Slide';
import { Icon } from '@genesis/ui-kit';
import axios from "axios";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { methods } from "underscore";
import { useNavigate } from "react-router-dom";
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import classes from "./eventlocationsdialog.module.scss";
import UnpublishedOutlinedIcon from '@mui/icons-material/UnpublishedOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { constants } from "../../../../Shared/Url/Constants";
import { toUpperCaseString } from '../../../../Shared/Utill/Utills';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const EventLocationsDialog = (props) => {
  const personDetails = useSelector((state) => state.person.personData);
  const urlDetails = useSelector((state) => state.url.urlData);
  const token = Cookies.get('X_TKN');
  const history = useNavigate();
  const dialog = useToggle();
  const [isAlertOpen, setAlertOpen] = React.useState({});
  const { message, severity, open } = isAlertOpen || {};
  const [eventRowData , setEventRowData] = useState(props.data);
  const [locationsListData, setLocationsListData] = useState(null); 

  useEffect(() => {
    dialog.show();
  }, []);

  useEffect(() => {
   setEventRowData(props.data);
   getLocationsListfromAPI();
  }, [props.data]);

  const dialogCLose = () => {
      dialog.hide();
      props.onCloseDialog();
  }

  const handleAlertNotifClose = () => {
      setAlertOpen({});
  };
  
  const getLocationsListfromAPI = () => {
      let eventId = eventRowData.eventid;
      axios({
        url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_EVNT_CONTROLS_GET_EVENT_LOCATIONS}/${eventId}`,
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'Authorization':'Bearer ' + token,
        },
      }).then((res) => {
        let resp = [];
        res.data.map((obj) => {
            let myObj = {};
            myObj.id = obj.location;
            myObj.location = obj.location;
            myObj.status = obj.status;
            resp.push(myObj);
        })
        setLocationsListData(resp);
      }).catch((err) => {
        setAlertOpen({
          open: true,
          severity: "error",
          message : "Something went wrong",
        })
      });


  }


  
  const columns = [
    { field: 'location', headerName: 'Included Locations', width: "260" },
    { field: 'status', headerName: 'Status', width: "100", renderCell: (params) => {
      if(toUpperCaseString(params.row.status) === "ACTIVE") {
        return (
        <div className="d-flex justify-content-between align-items-center">
        <CheckCircleOutlinedIcon style={{color:"#008757"}} /> <span style={{marginLeft:"5px" }}>Active</span>
        </div>);
      } else {
      return (
        <div className="d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer" }}>
        <UnpublishedOutlinedIcon /> <span style={{marginLeft:"5px" }}> Inactive </span>
        </div> 
      );
      }
    }},
    
  ];

  

    return (
      <Box>
        <Dialog
          fullScreen
          open={dialog.open}
          title='Locations'
          onClose={dialogCLose}
          TransitionComponent={Transition}
          PaperProps={{
            sx: {
                width: '41%',
                maxWidth: '41%',
                minHeight: "100%",
                display:"flex",
                left:'31%',     
            },
        }}
        >
        <div style={{marginTop:"-30px"}}>
        <div className={classes.pagesubtitle} >Event ID - {eventRowData.eventid}</div>
        <div className={classes.pagesubtitle}>Event Name - {eventRowData.eventname}</div>
        <div style={{marginTop:"10px"}}>
        {locationsListData && <Box  sx={{ height: 440, width: "100%", marginTop: 5 }}>
                               <DataGrid 
                                columns= { columns} 
                                rows = {locationsListData} 
                                components={{Footer: () => {return null}}} 
                                /> 
                              </Box>  }       
                              </div>
  
     
      </div>
      <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>
        </Dialog>
      </Box>
    );
  };
  
  export default EventLocationsDialog;